import { apiV1GetSubscription } from '@/modules/api/requests/subscription';

import { asyncActionUntillResult } from './asyncActionUntillResult';

export const pollUserSubscriptionUntilAttached = async () => {
  return await asyncActionUntillResult(
    apiV1GetSubscription,
    (result: unknown) => {
      return result !== null;
    },
    1_500,
    30_000,
  );
};
